import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { memo } from "react";
import { SwapPlanButton } from "../../../features/meal-plan/components/swap-plan-button";

interface MealPreviewCardProps {
  mealDay: string | undefined;
  mealIndex?: number;
  mealTime: MealTime;
  meal: Meal;
}

export const MealPreviewCard = memo(function MealPreviewCard({
  mealDay,
  mealIndex,
  mealTime,
  meal,
}: MealPreviewCardProps) {
  return (
    <div key={meal.id} className="w-64">
      <div className="m-0 rounded-2xl overflow-hidden">
        <div className="relative">
          <div className="w-64 h-80 rounded-t-2xl overflow-hidden">
            <img
              src={meal.imageUri}
              alt={meal.name}
              className="w-full h-full object-cover"
            />
          </div>

          <SwapPlanButton
            meal={meal}
            mealTime={mealTime}
            mealDay={mealDay}
            mealIndex={mealIndex}
            iconOnly
            className="absolute bottom-4 right-4"
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-between py-2 gap-2">
        <div className="flex w-full">
          <span className="text-sm text-gray-500 flex-1 text-left">
            {mealTime}
          </span>
        </div>
        <h6 className="w-full font-semibold text-black">{meal.name}</h6>
      </div>
    </div>
  );
});
